module.exports = __webpack_public_path__ + "static/media/article3.47a8fafd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/articles/article3.jpeg
// module id = 92
// module chunks = 0